export const downloadFile = async (response: Response) => {
    if (response.status === 200) {
        const blob = await response.blob();
        const fileName = (response.headers.get('content-disposition') || '').split("filename*=UTF-8''")[1] || 'download';

        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([blob], { type: blob.type }));
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
